import React, { Suspense, lazy } from 'react';
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import RootPage from "./RootPage";
import {SessionContextProvider} from "./context/SessionContextProvider";
import * as Const from "./Const";
// import MainPage from "./components/MainPage";
import UserLoginTab from "./components/UserLoginTab";
import UserRegistrationTab from "./components/UserRegistrationTab";
import UserConfirmationTab from "./components/UserConfirmationTab";
import MainPageV2 from "./components/MainPageV2";
import RainRoverMain from "./components/rainrover/RainRoverMain";
import useUserSessionInfo from "./hooks/useUserSessionInfo";
import {BASE_NAME} from "./Const";
import TestMainUi from "./components/TestMainUi";

// const UserLoginPage = lazy(() => import('./components/UserLoginPage'))
const UserHomePage = lazy(() => import('./components/UserHomePage'))
const SuccessPage = lazy(() => import('./components/SuccessPage'))


function App() {

    // noinspection JSUnresolvedVariable
    const isEmbedded = typeof RmAppJavaScriptInterface !== "undefined";
    const language = Const.LANG_EN;

    console.log("is embedded: " + isEmbedded);

    return (
        <SessionContextProvider>
            <BrowserRouter basename={Const.BASE_NAME}>
                <Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                        <Route exact path={"/rain"} element={<RainRoverMain />} />
                        <Route exact path={"/"} element={<Navigate to="/map" replace={true} />} />
                        <Route exact path={"/map"} element={<MainPageV2 />} />

                        <Route path={"/"} element={<RootPage />}>
                            <Route path={"user"}>
                                <Route path={"login"} element={<UserLoginTab language={language} isEmbedded={isEmbedded}/>}/>
                                <Route path={"new"} element={<UserRegistrationTab language={language} isEmbedded={isEmbedded}/>}/>
                                <Route path={"confirm"} element={<UserConfirmationTab language={language} isEmbedded={isEmbedded}/>} >
                                    <Route path={":userId"} element={<UserConfirmationTab language={language} isEmbedded={isEmbedded}/>} />
                                </Route>
                                <Route path={"home"} element={<UserHomePage language={language} isEmbedded={isEmbedded}/>}/>
                                <Route path={"success"} element={<SuccessPage language={language} isEmbedded={isEmbedded}/>}/>
                            </Route>
                        </Route>

                    </Routes>
                </Suspense>
            </BrowserRouter>
        </SessionContextProvider>
    );
}


export default App;
